import * as React from "react";
import PropTypes from "prop-types";
import Slider from "@mui/material/Slider";
import { styled } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import Box from "@mui/material/Box";
import causalValueFormatter from "src/scenes/causal-analysis/components/causal-value-formatter";

const ValueLabelComponent = (props) => {
    const { children, value } = props;
    return (
        <Tooltip enterTouchDelay={0} placement="top" title={value}>
            {children}
        </Tooltip>
    );
};

ValueLabelComponent.propTypes = {
    children: PropTypes.element.isRequired,
    value: PropTypes.number.isRequired,
};

const ExcellentSlider = styled(Slider)({
    color: "#52af77",
    height: 8,
    "& .MuiSlider-track": {
        border: "none",
    },
    "& .MuiSlider-thumb": {
        height: 18,
        width: 18,
        backgroundColor: "#fff",
        border: "2px solid currentColor",
        "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
            boxShadow: "inherit",
        },
        "&:before": {
            display: "none",
        },
    },
    "& .MuiSlider-valueLabel": {
        lineHeight: 1.2,
        fontSize: 11,
        background: "unset",
        padding: 0,
        width: 32,
        height: 32,
        borderRadius: "50% 50% 50% 0",
        backgroundColor: "#52af77",
        transformOrigin: "bottom left",
        transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
        "&:before": { display: "none" },
        "&.MuiSlider-valueLabelOpen": {
            transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
        },
        "& > *": {
            transform: "rotate(45deg)",
        },
    },
});

const formatLabel = (value, units) => {
    const formattedLabelValue = causalValueFormatter({ value, units, isSlider: true });
    return formattedLabelValue;
};

const calculateStep = (units) => {
    if (units && units.type === "duration") return 1;
    if (units && units.type === "unitless") return 0.1;
    if (units && units.type === "numeric") return 0.1;
    return null;
};
const AnalysisSlider = ({
    id,
    min,
    max,
    mean,
    std,
    units,
    defaultValue,
    setIsDirty,
    interventionData,
    setInterventionData,
}) => {
    const [sliderValue, setSliderValue] = React.useState(defaultValue);
    const handleChange = (event, newValue) => {
        setSliderValue(newValue);
        setIsDirty(true);
        setInterventionData({ ...interventionData, [id]: (newValue - mean) / std });
    };
    const handleClick = (event) => {
        event.stopPropagation();
    };

    return (
        <Box sx={{ width: "132px", paddingLeft: "16px" }}>
            <ExcellentSlider
                valueLabelDisplay="auto"
                aria-label="mission goal slider"
                value={sliderValue}
                onChange={handleChange}
                onClick={handleClick}
                min={min}
                max={max}
                step={calculateStep(units)}
                valueLabelFormat={formatLabel(sliderValue, units)}
            />
        </Box>
    );
};

export default AnalysisSlider;
